import React from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';
import Card from './Card';

const CardPreviewModal = ({ card, onClose }) => {
    if (!card) return null;

    return (
        <Modal onClose={onClose} title={`${card.year} ${card.name}`}>
            <div className="card-preview-modal">
                <Card card={card} fallbackSeriesKey={card.Series?.[0]?.seriesKey} />
                <p className="card-preview-hint">Click card to flip</p>
            </div>
        </Modal>
    );
};

CardPreviewModal.propTypes = {
    card: PropTypes.object,
    onClose: PropTypes.func.isRequired,
};

export default CardPreviewModal;
